import { apiClient } from "../../utils/apiClient";
import { Recurrente, RecurrenteFormData } from "../../types/recurrente";

export const fetchRecurrentes = async (
  search: string = "",
  user: string = "",
): Promise<Recurrente[]> => {
  const response = await apiClient.get("/recurrent-visits", {
    params: { search, user },
  });
  return response.data;
};

export const fetchRecurrentesActivas = async (
  search: string = "",
  activeOnly: boolean,
  notExpired: boolean,
): Promise<Recurrente[]> => {
  const response = await apiClient.get("/recurrent-visits", {
    params: {
      search,
      activeOnly,
      notExpired,
    },
  });
  return response.data;
};

export const fetchRecurrenteById = async (id: number): Promise<Recurrente> => {
  const response = await apiClient.get(`/recurrent-visits/${id}`);
  return response.data;
};

export const upsertRecurrente = async (
  recurrente: RecurrenteFormData,
  user: string,
  id?: number,
): Promise<Recurrente> => {
  if (id) {
    const response = await apiClient.put(`/recurrent-visits/${id}`, {
      ...recurrente,
      user,
    });
    return response.data;
  } else {
    const response = await apiClient.post("/recurrent-visits", {
      ...recurrente,
      user,
    });
    return response.data;
  }
};

export const toggleRecurrenteActive = async (
  id: number,
  user: string,
): Promise<void> => {
  await apiClient.patch(`/recurrent-visits/${id}/toggle`, { user });
};

export const checkLimiteVisitas = async (
  id: number,
): Promise<{
  puedeIngresar: boolean;
  visitas_realizadas: number;
  max_visitas: number;
  mensaje: string;
}> => {
  const response = await apiClient.get(`/recurrent-visits/${id}/check-limite`);
  return response.data;
};

export const incrementarVisitas = async (
  id: number,
  user: string,
): Promise<any> => {
  const response = await apiClient.post(
    `/recurrent-visits/${id}/incrementar-visita`,
    { user },
  );
  return response;
};
